import SharedNavbar from '../../../components/feature/SharedNavbar';
import SharedFooter from '../../../components/feature/SharedFooter';
import FloatingCallButton from '../../../components/feature/FloatingCallButton';
import ServiceHero from '../components/ServiceHero';
import ServiceContent from '../components/ServiceContent';
import ServiceCTA from '../components/ServiceCTA';

export default function PowerPointsPage() {
  const serviceData = {
    title: 'Power Point Installation & Repair',
    subtitle: 'Safe & Reliable Power Solutions',
    description: 'Need additional power points or repairs to existing outlets? Our licensed electricians provide professional power point installation, relocation, and repair services. We ensure all work meets Australian safety standards and building codes.',
    heroImage: 'https://public.readdy.ai/ai/img_res/05b08149e7227779b9240f7ad4e40a23.jpg',
    features: [
      {
        icon: 'ri-plug-line',
        title: 'New Installations',
        description: 'Add power points exactly where you need them'
      },
      {
        icon: 'ri-arrow-left-right-line',
        title: 'Relocations',
        description: 'Move outlets to more convenient locations'
      },
      {
        icon: 'ri-usb-line',
        title: 'USB Outlets',
        description: 'Modern USB-integrated power points'
      },
      {
        icon: 'ri-shield-check-line',
        title: 'Safety Upgrades',
        description: 'Replace old or damaged outlets'
      }
    ],
    benefits: [
      'Additional power point installation',
      'Power point relocation services',
      'USB charging outlet installation',
      'Outdoor weatherproof outlets',
      'Safety switch protected circuits',
      'Repair of faulty power points',
      'Compliance with AS/NZS 3000',
      'Neat and tidy installation'
    ],
    processSteps: [
      {
        number: '01',
        title: 'Assessment',
        description: 'Evaluate your power needs and optimal locations'
      },
      {
        number: '02',
        title: 'Planning',
        description: 'Design the most efficient and safe solution'
      },
      {
        number: '03',
        title: 'Installation',
        description: 'Professional wiring and mounting of outlets'
      },
      {
        number: '04',
        title: 'Testing',
        description: 'Thorough safety testing and certification'
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SharedNavbar />
      <ServiceHero 
        title={serviceData.title}
        subtitle={serviceData.subtitle}
        description={serviceData.description}
        heroImage={serviceData.heroImage}
      />
      <ServiceContent 
        features={serviceData.features}
        benefits={serviceData.benefits}
        processSteps={serviceData.processSteps}
      />
      <ServiceCTA />
      <div className="pb-20 lg:pb-0">
        <SharedFooter />
      </div>
      <FloatingCallButton />
    </div>
  );
}